module.exports = __webpack_public_path__ + "img/maqiang.f57c6fdb.jpg";